import { LanguageSelect as LanguageSelectComponent } from '@gisce/oficina-virtual-components';
import useLangs from '../../languages/hooks/useLangs';

export const LanguageDropdownMenu = () => {
  const { 
    availableLangsData, 
    currentLangData, 
    changeLang,
  } = useLangs();

  return (
    <LanguageSelectComponent 
      availableLanguages={availableLangsData}
      currentLanguage={currentLangData}
      handleLanguageSelect={(langData) => changeLang(langData.value)}
    />
  );
}